import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry, SentryAppBoundary } from "@/lib/sentry";

initSentry();

console.info("[TLA] build", process.env.REACT_APP_BUILD_SHA || "dev");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryAppBoundary>
      <App />
    </SentryAppBoundary>
  </React.StrictMode>,
);
